import { render, staticRenderFns } from "./BaseSubmitButton.vue?vue&type=template&id=0c4f4c1e&"
import script from "./BaseSubmitButton.vue?vue&type=script&lang=js&"
export * from "./BaseSubmitButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports